class HapticManager {
    constructor() {
        this._hapticEnabled = true;
        this.setHapticEnabled(true);
    }

    isHapticEnabled() {
        return this._hapticEnabled;
    }

    setHapticEnabled(value) {
        this._hapticEnabled = value;
    }

    toggleHaptic() {
        this._setHapticEnabled(!this._hapticEnabled);
    }
}
export default HapticManager;